import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap5/Form';
import { ErrorMessage, Field } from 'formik';

export default function CheckboxField({
  id, name, label, hint, required,
}) {
  return (
    <Form.Group className="mb-3 form-check form-check-inline" controlId={id}>
      {label && (
        <Form.Label className="form-check-label">
          <>
            {label}
            {required && <abbr className="ms-1" title="required">*</abbr>}
          </>
        </Form.Label>
      )}

      <Field
        type="checkbox"
        id={id}
        name={name}
        className="form-check-input"
      />

      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}

      <ErrorMessage
        name={name}
        render={(msg) => <Form.Control.Feedback type="invalid">{msg}</Form.Control.Feedback>}
      />
    </Form.Group>
  );
}

CheckboxField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  hint: PropTypes.string,
  required: PropTypes.bool,
};

CheckboxField.defaultProps = {
  label: '',
  hint: '',
  required: false,
};
